// The ONE chrome icon set for the runtime and the Studio (ASK-135 §5 v2.2 / D-072).
//
// WHAT THIS REPLACES. Editor controls were drawn with whatever glyph was to hand — ＋ 📌 ⟲ ✕
// 🗑 ↗ 👁 ↶ ↻ ✎ ⧉ ⊕. Three problems, all measured rather than aesthetic:
//   · an EMOJI glyph (📌 🗑 📷 📦) is painted by the OS emoji font in ITS OWN COLOURS, so it
//     ignores `currentColor` and cannot follow a token — the pin stayed brown on a blue button;
//   · every glyph has its own weight, size and baseline, so a row of them never lines up;
//   · a fullwidth ＋ is a different character from a plus and sorts/reads as CJK punctuation.
//
// So: one 24-grid, 1.5 px stroke, `currentColor`, `--gg-icon-size-*`. Same vocabulary GCG and
// meshsmith adopted, so "close" is the same mark in all three tools.
//
// The path data is the Feather/Lucide geometry the platform already draws elsewhere (the basket
// and flip icons in app.js are from the same set), so the weight matches without tuning.

export const ICONS = {
	close:     '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>',
	plus:      '<path d="M12 5v14"/><path d="M5 12h14"/>',
	pin:       '<path d="M12 17v5"/><path d="M9 10.76V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v5.76a2 2 0 0 0 .59 1.42l1.12 1.12A2 2 0 0 1 17 15.7v.3a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-.3a2 2 0 0 1 .29-1.4l1.12-1.12A2 2 0 0 0 9 10.76z"/>',
	unpin:     '<path d="M3 12a9 9 0 1 0 2.64-6.36"/><path d="M3 3v6h6"/>',
	trash:     '<path d="M3 6h18"/><path d="M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2"/><path d="M19 6v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6"/>',
	jump:      '<path d="M7 17 17 7"/><path d="M8 7h9v9"/>',
	eye:       '<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z"/><circle cx="12" cy="12" r="3"/>',
	eyeOff:    '<path d="M2 12s3.5-7 10-7c2 0 3.7.6 5.1 1.5"/><path d="M22 12s-3.5 7-10 7c-2 0-3.7-.6-5.1-1.5"/><path d="M9.9 9.9a3 3 0 0 0 4.2 4.2"/><path d="m3 3 18 18"/>',
	undo:      '<path d="M3 7v6h6"/><path d="M3.5 13a9 9 0 1 0 2.13-5.36L3 10"/>',
	refresh:   '<path d="M21 12a9 9 0 1 1-2.64-6.36"/><path d="M21 3v6h-6"/>',
	pencil:    '<path d="M17 3a2.85 2.85 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5z"/>',
	copy:      '<rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>',
	warn:      '<path d="M12 9v4"/><path d="M12 17h.01"/><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>',
	camera:    '<path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3z"/><circle cx="12" cy="13" r="3"/>',
	box:       '<path d="m21 8-9-5-9 5 9 5 9-5z"/><path d="M3 8v8l9 5 9-5V8"/><path d="M12 13v8"/>',
	check:     '<path d="M20 6 9 17l-5-5"/>',
	play:      '<path d="m6 3 14 9-14 9V3z"/>',
	grid:      '<rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18"/><path d="M9 3v18"/>',
	receipt:   '<path d="M4 2v20l3-2 3 2 3-2 3 2 3-2V2l-3 2-3-2-3 2-3-2-3 2z"/><path d="M8 8h8"/><path d="M8 12h8"/>',
	chart:     '<path d="M3 3v18h18"/><path d="M7 15l4-5 3 3 5-7"/>',
	settings:  '<circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9v0a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>',
	minus:     '<path d="M5 12h14"/>',
};

/**
 * Inline SVG for a chrome icon.
 * @param {keyof typeof ICONS} name
 * @param {"panel"|"header"} [size] 16 px (default) or 20 px, both from the token sheet.
 * @returns {string} SVG markup, or "" for an unknown name (never a fallback glyph — a missing
 *   icon must LOOK missing, not silently draw something else).
 */
export function icon(name, size = "panel") {
	const d = ICONS[name];
	if (!d) return "";
	const cls = size === "header" ? "kapowx-icon kapowx-icon--header" : "kapowx-icon";
	return `<svg class="${cls}" viewBox="0 0 24 24" aria-hidden="true">${d}</svg>`;
}
